export default function createPendingInvestmentTotalsTableDefinition() {
  return [{
    field: 'avInvestmentATotal',
    headerName: 'Total A Amount',
    description: 'Total A Amount',
    editable: false,
    flex: 1,
    minWidth: 300,
    sortable: false,
    filterable: false,
  },
  {
    field: 'avInvestmentQTotal',
    headerName: 'Total Q Amount',
    description: 'Total Q Amount',
    editable: false,
    flex: 1,
    minWidth: 300,
    sortable: false,
    filterable: false,
  },
  {
    field: 'avInvestmentTotal',
    headerName: 'Total AV Check',
    description: 'Grand Total',
    editable: false,
    flex: 1,
    minWidth: 300,
    sortable: false,
    filterable: false,
  }];
}
